<template>
    <div>

   
          <base-navigation></base-navigation>

    <div class="send-sms">
      <h2>Send SMS to Members</h2>
      <form @submit.prevent="sendSms">
        <div class="form-group">
          <label for="message">Message:</label>
          <textarea id="message" v-model="message" required></textarea>
        </div>
  
        <div class="form-group">
          <label for="amount">Amount:</label>
          <input type="number" id="amount" v-model="amount" required />
        </div>
  
        <button type="submit" :disabled="loading">
          {{ loading ? "Sending..." : "Send SMS" }}
        </button>
  
        <p v-if="responseMessage" class="response">{{ responseMessage }}</p>
      </form>
    </div>
</div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        message: "",
        amount: "",
        responseMessage: "",
        loading: false,
      };
    },
    methods: {
      async sendSms() {
        if (!this.message || !this.amount) {
          this.responseMessage = "Please fill in all fields.";
          return;
        }
  
        this.loading = true;
        this.responseMessage = "";
  
        try {
          const token = localStorage.getItem("token"); // Retrieve token from storage
          console.log(token)
  
          const response = await axios.post(
            "https://api.roberms.com/gafwa/send/annoucement/sms",
            {
              message: this.message,
              amount: this.amount,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          this.responseMessage = response.data.message;
          this.message = "";
          this.amount = "";
        } catch (error) {
          this.responseMessage = error.response.data.message;
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .send-sms {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #f9f9f9;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    font-weight: bold;
  }
  
  textarea,
  input {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  button {
    width: 100%;
    padding: 10px;
    border: none;
    background-color: #007bff;
    color: white;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .response {
    margin-top: 10px;
    font-weight: bold;
    color: green;
  }
  </style>
  